import { useSelector } from 'react-redux'
import { useSetAtom } from 'jotai'

import { dayByDeliveryDateSelector } from 'src/components/DeliveryCard/selectors'
import { skipConfirmationModalAtom } from 'src/atoms/modals/skipConfirmationModal.atom'
import { useDeflectionWithPromoStrategy } from './useDeflectionWithPromoStrategy'

export function useSkipOrderDeflection({ date }) {
  const day = useSelector(state => dayByDeliveryDateSelector(state, date))
  const setSkipConfirmationModal = useSetAtom(skipConfirmationModalAtom)
  const {
    enabled: deflectionStrategyEnabled,
    triggerStrategy
  } = useDeflectionWithPromoStrategy()

  function handleOnSkip() {
    if (deflectionStrategyEnabled) {
      triggerStrategy({
        type: 'skip',
        payload: { date: day.date, displayDate: day.displayDate },
        onContinue: openSkipConfirmationModal
      })
    } else {
      openSkipConfirmationModal()
    }
  }

  function openSkipConfirmationModal() {
    setSkipConfirmationModal({ isOpen: true, date: day.displayDate })
  }

  return {
    handleOnSkip
  }
}
